import { render, staticRenderFns } from "./Expander.vue?vue&type=template&id=09a21177&"
import script from "./Expander.vue?vue&type=script&lang=js&"
export * from "./Expander.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/neuronet/projekty/gantt-elastic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09a21177')) {
      api.createRecord('09a21177', component.options)
    } else {
      api.reload('09a21177', component.options)
    }
    module.hot.accept("./Expander.vue?vue&type=template&id=09a21177&", function () {
      api.rerender('09a21177', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Expander.vue"
export default component.exports